import { useComputedColorScheme } from '@mantine/core';

export function CustomerLogo({ size = 'md' }: { size?: 'sm' | 'md' }) {
  const scheme = useComputedColorScheme('light');
  const height = size === 'sm' ? 17 : 22;
  const width = Math.round((height * 429.1) / 65.3);

  return (
    <span role="img" aria-label="ScalePad" style={{ display: 'inline-flex', flex: '0 0 auto' }}>
      <img src={scheme === 'dark' ? '/brand/scalepad-wordmark-white.png' : '/brand/scalepad-wordmark.svg'}
        alt="" aria-hidden width={width} height={height} style={{ display: 'block', width, height }} />
    </span>
  );
}
